export default "__VITE_ASSET__B6kwp6U___"